const LOCAL_API_ORIGIN = 'http://127.0.0.1:8000';

const isLocalDev = (): boolean => {
  if (typeof window === 'undefined') return false;

  const { hostname, protocol } = window.location;
  return protocol === 'file:' || hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';
};

const getApiBaseUrl = (): string => {
  if (typeof window === 'undefined') return LOCAL_API_ORIGIN;
  if (isLocalDev()) return LOCAL_API_ORIGIN;
  return window.location.origin;
};

export const API_BASE_URL = getApiBaseUrl();

// ローカル: uvicorn 直叩き（/api なし） / 本番: nginx 経由（/api 付き）
export const API_PATHS = {
  contact: isLocalDev() ? '/contact' : '/api/contact',
  recruitContact: isLocalDev() ? '/recruit-contact' : '/api/recruit-contact',
} as const;
